import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap, X, ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const isReturningCampaignVisitor = () => {
  try {
    return Boolean(localStorage.getItem("vsk_cmp")) && Number(localStorage.getItem("vsk_visits") || 0) >= 2;
  } catch {
    return false;
  }
};

export const useVisitCounter = () => {
  useEffect(() => {
    try {
      if (!sessionStorage.getItem("vsk_visit_counted")) {
        sessionStorage.setItem("vsk_visit_counted", "1");
        localStorage.setItem("vsk_visits", String(Number(localStorage.getItem("vsk_visits") || 0) + 1));
      }
    } catch { /* ignore */ }
  }, []);
};

export const WelcomeBackBanner = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(isReturningCampaignVisitor()); }, []);
  if (!show || (user && user !== false)) return null;
  return (
    <div className="bg-[#0E2038] border-b border-[#007AFF]/30" data-testid="welcome-back-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-white">
          <span className="font-black">Welcome back!</span>{" "}
          <span className="text-neutral-300">Your founder spot is still open — first month FREE, unlimited listings.</span>
        </p>
        <Link
          to="/register?role=seller"
          data-testid="welcome-back-cta"
          className="inline-flex items-center gap-1.5 rounded-full bg-[#007AFF] hover:bg-[#1a86ff] text-white text-xs font-bold px-4 py-2 transition-colors"
        >
          Claim it now <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
};

export const StickyFounderBar = ({ promo }) => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem("vsk_founder_bar") === "closed"; } catch { return false; }
  });
  if (dismissed || (user && user !== false)) return null;
  if (promo && promo.remaining === 0) return null;
  const close = () => {
    setDismissed(true);
    try { sessionStorage.setItem("vsk_founder_bar", "closed"); } catch { /* ignore */ }
  };
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 border-t border-[#FF3B30]/40 bg-black/90 backdrop-blur-xl"
      data-testid="sticky-founder-bar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <img src="/logo.png" alt="" className="h-8 w-8 rounded-md border border-[#FF3B30]/30 hidden sm:block" />
          <p className="text-sm text-white truncate">
            <span className="font-black text-[#FF3B30]">First month FREE</span>
            <span className="text-neutral-300"> — </span>
            <span className="font-semibold">
              {promo?.remaining != null ? `${promo.remaining} founder spots left` : "claim your founder spot"}
            </span>
            <span className="hidden md:inline text-neutral-400"> · unlimited listings · keep $99.80 of every $100</span>
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link
            to="/register?role=seller"
            data-testid="sticky-founder-cta"
            className="inline-flex items-center gap-1.5 rounded-full bg-[#FF3B30] hover:bg-[#e0342a] text-white text-xs sm:text-sm font-bold px-4 sm:px-5 py-2 transition-colors"
          >
            <Zap className="h-3.5 w-3.5" /> Claim founder spot
          </Link>
          <button
            onClick={close}
            aria-label="Dismiss"
            data-testid="sticky-founder-close"
            className="p-1.5 rounded-full text-neutral-500 hover:text-white hover:bg-white/10 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
